import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import {
  CHANGE_CONTENT_PAGE,
  CONTENT_SEARCH_SUCCESS,
  SEARCH_SUCCESS,
  UPDATE_SEARCH_PARAMS_FROM_URL,
  UPDATE_SEARCH_TEXT,
} from "../actionTypes";
import { type ContentDataItem, type PaginationData, type SearchResultData } from "~/utils/models";

export interface ContentState {
  contentResults: ContentDataItem[];
  contentPagination: Omit<PaginationData, "currentPage">;
  contentPage: number;
}

export const contentInitialState: ContentState = {
  contentResults: [],
  contentPagination: {
    pageSize: 0,
    numberOfPages: 0,
    totalNumberOfResults: 0,
  },
  contentPage: 0,
};

export const contentSlice = createSlice({
  name: "content",
  initialState: contentInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .addCase(
        CONTENT_SEARCH_SUCCESS,
        (state, action: PayloadAction<{ results: ContentDataItem[]; pagination: PaginationData }> | any) => {
          const { results, pagination } = action.payload;
          state.contentResults = results;
          state.contentPagination = pagination;
        },
      )
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .addCase(CHANGE_CONTENT_PAGE, (state, action: PayloadAction<number> | any) => {
        state.contentPage = action.payload;
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .addCase(
        SEARCH_SUCCESS,
        (state, action: PayloadAction<{ data: SearchResultData; ignoreContent?: boolean }> | any) => {
          const { data, ignoreContent } = action.payload;
          if (!ignoreContent) {
            state.contentResults = data.content.results;
            state.contentPagination = data.content.pagination;
          }
        },
      )
      .addCase(UPDATE_SEARCH_PARAMS_FROM_URL, (state) => {
        state.contentPage = 0;
      })
      .addCase(UPDATE_SEARCH_TEXT, (state) => {
        state.contentPage = 0;
      });
  },
});

export const contentReducer = contentSlice.reducer;
